export default "__VITE_ASSET__3ef9169b__"